module.exports = __webpack_public_path__ + "img/dc-air-quality.7a043c6e.svg";